import * as React from 'react';
import { AnyObjectSchema, object } from 'yup';

export const formValidatorContext = React.createContext<AnyObjectSchema>(object());
